import {$, w} from './constants';
import { trackEvent } from "./gtm.js";

export function initializeHomeSlider(sliderClass, breakpoint) {
    $(sliderClass).each(function() {
        const $slider = $(this);
        let lastSlideIndex = 0;
        let isVisible = false;

        const gtmEventName = $slider.attr("data-gtm-event");

        $slider.on('init reInit', function(event, slick) {
            $(slick.$slides[slick.currentSlide]).css({
                'opacity': '1',
                'transition': 'none'
            });
        });        

        $slider.slick({
            arrows: false,
            dots: true,
            dotsClass: 'dots',
            appendDots: $('.dots-container__desktop'),
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000, 
            pauseOnHover: true,
            speed: 250,
            fade: true,
            lazyLoad: 'ondemand',
            cssEase: 'linear',
            adaptiveHeight: true
        });

        $slider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
            lastSlideIndex = currentSlide;
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            const $currentSlide = $(slick.$slides[currentSlide]);
            const $nextSlide = $(slick.$slides[nextSlide]);

            const currentVideo = $currentSlide.find('video');
            const nextVideo = $nextSlide.find('video');

            if (currentVideo.length) {
                currentVideo.get(0).pause();
                currentVideo.get(0).muted = true;
            }

            if (nextVideo.length) {
                nextVideo.get(0).play();
            }

            const currentYTId = $currentSlide.find('.js-youtube-player-wrap').data('video-id');
            const nextYTId = $nextSlide.find('.js-youtube-player-wrap').data('video-id');

            const currentYT = window.gbmYTPlayers?.[currentYTId];
            const nextYT = window.gbmYTPlayers?.[nextYTId];

            if (currentYT?.pauseVideo) {
                currentYT.pauseVideo();
            }

            if (nextYT?.playVideo) {
                nextYT.playVideo();
            }
        });

        // Tracking de swipe pero solo si el slider está en viewport
        function handleSlideChange(event, slick, currentSlide) {
            if (!isVisible) return;

            const direction = currentSlide > lastSlideIndex ? 'next' : 'prev';

            trackEvent(gtmEventName, {
                slideIndex: currentSlide + 1,
                swipeDirection: direction
            });
        }

        $slider.on("afterChange", handleSlideChange);

        //Ocultar imágenes según el dispositivo
        if ($(window).width() < breakpoint) {
            hideImgsOnMobile($slider);
        } else {
            hideImgsOnDesktop($slider);
        }

        let is_changed = { mobile: false, desktop: false };

        $(window).resize(function () {
            if ($(window).width() < breakpoint && !is_changed.mobile) {
                is_changed.desktop = false;
                is_changed.mobile = true;
                hideImgsOnMobile($slider);
            }

            if ($(window).width() >= breakpoint && !is_changed.desktop) {
                is_changed.mobile = false;
                is_changed.desktop = true;
                hideImgsOnDesktop($slider);
            }
        });

        // Detectar si el Slider está en el Viewport
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    isVisible = true;
                } else {
                    isVisible = false;
                }
            });
        }, { threshold: 0.5 }); // Se activa cuando al menos el 50% del slider está en viewport

        observer.observe($slider[0]);
    });

    function hideImgsOnMobile(slider) {
        slider.slick('slickUnfilter');
        slider.slick('slickFilter', function() {
            return $(this).find(
                'img.mobile, img.no-filter, video.video-hero-mobile, .no-filter'
            ).length > 0;
        });
    }

    function hideImgsOnDesktop(slider) {
        slider.slick('slickUnfilter');
        slider.slick('slickFilter', function() {
            return $(this).find(
                'img.desktop, img.no-filter, video.video-hero-desktop, .no-filter'
            ).length > 0;
        });
    }
}

export function initializeTestimonialsSlider( sliderId ){
    $(sliderId).each(function(){
        $(this).slick({
            arrows: true,
            prevArrow: "<div class='arrow-testimonials arrow-testimonials--left'>",
            nextArrow: "<div class='arrow-testimonials arrow-testimonials--right'>",
            dots: true,
            dotsClass: 'dots-testimonials',
            appendDots: $('.dots-testimonials__container'),
            infinite: true,
            autoplay: true,
            autoplaySpeed: 8000, // Tiempo entre cambios de slide (8 segundos)
            pauseOnHover: true,
            speed: 250, // Velocidad del fade entre slides (250ms)
            fade: true,
            lazyLoad: 'ondemand',
            cssEase: 'linear',
            adaptiveHeight: false
        });
    });
}

export function initializeAFASSlider( sliderId ){
    $(sliderId).each(function(){
        $(this).slick({
            arrows: true,
            prevArrow: "<div class='arrow-afas arrow-afas--left'>",
            nextArrow: "<div class='arrow-afas arrow-afas--right'>",
            infinite: false,
            autoplay: false,
            speed: 250, // Velocidad del fade entre slides (250ms)
            lazyLoad: 'ondemand',
            cssEase: 'linear',
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 951,
                    settings: {
                      slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 651,
                    settings: {
                      slidesToShow: 1.2,
                    }
                }
            ]
        });
    });
}

export function initializeSliderAdvisory( sliderID ){
    $(sliderID).each(function(){
        $(this).slick({
            arrows: false,
            dots: true,
            dotsClass: 'dots',
            appendDots: $('.dots-container__desktop'),
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000, 
            pauseOnHover: true,
            speed: 250,
            fade: true,
            lazyLoad: 'ondemand',
            cssEase: 'linear',
        });
    });
    
}
export function sliderGrab() {
    const sliders = document.querySelectorAll('.slider--grab');

    sliders.forEach(slider => {
        const container = slider.closest('.slider-container');
        if (!container) return;

        const leftArrow = container.querySelector('.slider-arrow--left');
        const rightArrow = container.querySelector('.slider-arrow--right');
        const gtmEvent = container.getAttribute("data-event-gtm"); // Obtenemos el evento GTM

        let lastScrollLeft = slider.scrollLeft;
        let lastTrackedDirection = null;
        let isScrolling = false;

        if (gtmEvent) {
            slider.addEventListener('scroll', () => {
                if (!isScrolling) {
                    isScrolling = true;

                    // Usamos `requestAnimationFrame` para reducir la carga del evento
                    requestAnimationFrame(() => {
                        const currentScrollLeft = slider.scrollLeft;
                        const direction = currentScrollLeft > lastScrollLeft ? 'right' : 'left';

                        if (direction !== lastTrackedDirection) {
                            lastTrackedDirection = direction;

                            trackEvent(gtmEvent, {
                                sliderId: container.id,
                                action: "swipe",
                                direction: direction
                            });
                        }

                        lastScrollLeft = currentScrollLeft;
                        isScrolling = false;
                    });
                }
            });
        }

        // Función para verificar el desbordamiento y mostrar/ocultar flechas
        const checkScroll = () => {
            if (slider.scrollWidth > slider.clientWidth) {
                container.classList.add('show-arrows');
            } else {
                container.classList.remove('show-arrows');
            }
        };

        checkScroll();
        window.addEventListener('resize', checkScroll);

        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3;
            slider.scrollLeft = scrollLeft - walk;
        });

        //Funcionalidad de las flechas
        const scrollAmount = 200;
        if (leftArrow && rightArrow) {
            leftArrow.addEventListener('click', () => {
                slider.scrollTo({
                    left: slider.scrollLeft - scrollAmount,
                    behavior: 'smooth'
                });
            });

            rightArrow.addEventListener('click', () => {
                slider.scrollTo({
                    left: slider.scrollLeft + scrollAmount,
                    behavior: 'smooth'
                });
            });
        }

        const observer = new MutationObserver(checkScroll);
        observer.observe(slider, { childList: true });
    });
}
    
export function sameHeightSlides(container ){
    const blocks = $(container).find('.slider-block');
    let maxHeight = 0;

    // Calcular la altura máxima
    blocks.each(function() {
        const dataContainerHeight = $(this).find('.data-container').outerHeight();
        if (dataContainerHeight > maxHeight) {
            maxHeight = dataContainerHeight;
        }
    });

    // Aplicar la altura máxima a todos los contenedores
    blocks.each(function() {
        $(this).find('.data-container').css('height', maxHeight + 'px');
    });
}

export function sameHeightSliders(containerClass) {

    const sliders = $(containerClass);

    sliders.each(function() {
        const slider = $(this);
        const blocks = slider.find('.slider-block');

        let maxHeight = 0;

        // Restablecer altura antes de calcularla
        blocks.find('.data-container').css('height', '');

        // Calcular la altura máxima para este slider
        blocks.each(function() {
            const dataContainerHeight = $(this).find('.data-container').outerHeight();
            maxHeight = Math.max(maxHeight, dataContainerHeight);
        });

        // Aplicar la altura máxima a todos los contenedores de este slider
        blocks.each(function() {
            $(this).find('.data-container').css('height', maxHeight + 'px');
        });
    });
}

export function initializeFaqsSlider( sliderId ){
    $(sliderId).each(function(){
        $(this).slick({
            arrows: true,
            prevArrow: "<div class='arrow-faqs arrow-faqs--left'>",
            nextArrow: "<div class='arrow-faqs arrow-faqs--right'>",
            appendArrows: $('.faqs-archive__news-arrows'),
            infinite: true,
            autoplay: false,
            speed: 250, // Velocidad del fade entre slides (250ms)
            lazyLoad: 'ondemand',
            cssEase: 'linear',
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 951,
                    settings: {
                      slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 651,
                    settings: {
                      slidesToShow: 1,
                    }
                }
            ]
        });
    });
}
